import { useCompany, fmtNipc, brand } from "../../context/CompanyContext";

const LEGACY = {
  legal_name: "LuxStay Madeira",
  nipc: "257794158",
  address: "Ponta do Sol & Funchal",
  city: "Madeira",
};

/** Brand name to use inside contract prose (legacy for old signed contracts). */
export const contractBrand = (contract) =>
  contract?.issuer?.trade_name || (contract?.status === "signed" ? LEGACY.legal_name : brand());

/** Entity on a contract: frozen issuer → legacy (old signed) → current company. */
export function useContractIssuer(contract) {
  const { company } = useCompany();
  if (contract?.issuer) return contract.issuer;
  if (contract?.status === "signed") return LEGACY;
  return company;
}

export default function ProviderParty({ contract, className = "", textClass = "text-[11.5px]" }) {
  const { company } = useCompany();
  const iss = useContractIssuer(contract);
  const seat = [iss.address, iss.postal_code, iss.city].filter(Boolean).join(" · ") || "—";
  return (
    <div className={className} data-testid="contract-provider-party">
      <div className="text-[10px] tracking-[0.14em] uppercase text-[#d4af37] font-semibold">
        Primeira Outorgante · Prestadora
      </div>
      <div className="mt-1 font-display text-base text-[#fdfbf7]" data-testid="contract-provider-name">{iss.legal_name}</div>
      <div className={`mt-2 ${textClass} text-[#cfd8d6] leading-relaxed`}>
        <strong>NIF/NIPC:</strong> {fmtNipc(iss.nipc) || "—"}<br />
        <strong>Sede:</strong> {seat}<br />
        <strong>Email:</strong> {company.email}<br />
        <strong>Telefones:</strong> {company.phone} · {company.whatsapp}
      </div>
    </div>
  );
}
